// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__unjMo","breaker":"Navigation_breaker__Tq2qW","slider":"Navigation_slider__Hu6+X"};